import { message } from "antd"; // Importing message for notifications
import axios from "axios";
import { useContext, useEffect } from "react";
import { BookingContext } from "../../../../../components/BookingContext"; // Context for managing booking details

export const usePaymentMethod = () => {
  const { setPaymentMethod, paymentMethod } = useContext(BookingContext); // Access both method and setter

  // Fetch payment method from the backend
  useEffect(() => {
    const fetchPaymentMethod = async () => {
      try {
        const response = await axios.get("/api/paymentMethod/getPaymentMethod");
        const method = response.data?.method || "creditCard"; // Default to 'creditCard' if not set
        setPaymentMethod(method); // Set payment method from the backend
      } catch (error) {
        console.error("Error fetching payment method:", error);
      }
    };

    fetchPaymentMethod();
  }, [setPaymentMethod]);

  const handlePaymentSelection = async (method) => {
    try {
      await axios.post("/api/paymentMethod/updatePaymentMethod", { method });
      console.log(`Payment method updated to: ${method}`);
      setPaymentMethod(method); // Update the global payment method in context
      message.success(`Payment method updated to: ${method}`);
    } catch (error) {
      console.error("Error updating payment method:", error);
    }
  };

  return {
    paymentMethod,
    handlePaymentSelection,
  };
};
